@defer (when value()) {
  <app-role-form
    [details]="true"
    [profile]="profile()"
    [access]="access()"
    [(value)]="value"
    [id]="id"
  ></app-role-form>
}
